<template>
  <div>
    <v-row class="mx-4 mt-2">
      <v-col cols="12" md="4">
        <h2 class="text-left">Staff Attendance Details</h2>
      </v-col>
      <v-col cols="12" md="2"> </v-col>
    </v-row>

    <v-row no-gutters>
      <!-- date-range,chart column -->
      <v-col cols="12" md="3" order-md="2" v-if="currentStaff && currentUser.privileges.canViewStaffAttendanceAnalytics">
        <v-card class="px-2 py-3 mx-5 my-2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dateRange"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <!-- Date-range picker -->
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formattedDateRange"
                label="Select Date Range"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                class="rounded-input"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateRange" no-title scrollable range>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
              <v-btn
                text
                color="primary"
                @click="getStaffAttendanceAnalytics()"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>

          <!-- Attendance chart -->
          <div
            class="d-flex justify-center"
            v-if="dateRange && dateRange.length == 2 && chartData"
          >
            <StaffAttendanceAnalytics
              :series="[this.chartData.total_present_days, this.chartData.total_OT_days,this.chartData.paid_leaves, this.chartData.unpaid_leaves, this.chartData.half_days, this.chartData.total_absent_days, this.chartData.holidays, this.chartData.weekoffs]"
              :labels="['Total Present','Total Overtime Days','Total Paid Leave', 'Total Unpaid Leave', 'Total Absent Days','Total Half Day', 'Total Holiday', 'Total Weekly-off']"
              :colors="['#4CD137','pink' ,'#ff9800', '#FF0000','#800000','#fdd835', '#2196f3', '#6a0dad']"

            />
          </div>

          <!-- analytics display -->
          <div
            class="mt-3"
            v-if="dateRange && dateRange.length == 2 && chartData"
          >
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                 <strong>Total Working Days: {{chartData.working_days || '-' }}</strong>
              </p>
            </div>
            <v-divider></v-divider>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
               Total Present Days: {{ chartData.total_present_days || '-' }}
              </p>
            </div>
            <div>
              <p class="text--darken-4 font-weight-medium text-left mx-4 mb-1">
                Total Absent: {{ chartData.total_absent_days || '-'}}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Overtime: {{ chartData.total_OT_days || '-'}}
              </p>
            </div>
            <div>
              <p class="darken-3 font-weight-medium text-left mx-4 mb-1">
                Total Paid Leaves: {{ chartData.paid_leaves || '-' }}
              </p>
            </div>
            <div>
              <p class="text--darken-1 font-weight-medium text-left mx-4 mb-1">
                Total Unpaid Leaves: {{ chartData.unpaid_leaves || '-'}}
              </p>
            </div>
            <div>
              <p class="text--darken-1 font-weight-medium text-left mx-4 mb-1">
                Total Half Days: {{ chartData.half_days || '-' }}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Holiday: {{ chartData.holidays || '-' }}
              </p>
            </div>
            <div>
              <p class="font-weight-medium text-left mx-4 mb-1">
                Total Weekly-Off: {{ chartData.weekoffs || '-' }}
              </p>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- data table column -->
      <v-col order-md="1" cols="12" md="9 ">
        <v-card class="ma-5">
          <v-row class="mx-4">
            <v-col cols="12" md="4" class="my-1">
              <v-autocomplete
                dense
                filled
                rounded
                solo
                :items="ownView"
                label="Select Staff"
                class="mt-4 font-weight-bold"
                item-value="id"
                item-text="full_name"
                hide-details
                return-object
                v-model="currentStaff"
                @change="getAttendanceFromId()"
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.full_name"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html=" data.item.username + (data.item.employee_id ? ` (${data.item.employee_id})` : '') "
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
            <v-col cols="12" md="5"> </v-col>
            <v-col cols="12" md="3" align-self="center">
              <div v-if="currentUser.privileges.canExportStaffAttendanceDetails">
                <!-- Export button -->
                <download-excel
                  :fetch="getExportData"
                  :fields="export_fields"
                  :name="getExportName()"
                  v-if="currentStaff"
                >
                  <v-btn
                    class="text-right"
                    :loading="export_in_progress"
                    :disabled="export_in_progress"
                    color="white"
                    elevation="2"
                  >
                    Export
                    <v-icon right dark> mdi-export </v-icon>
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>mdi-cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                </download-excel>
              </div>
            </v-col>
            <v-col cols="12" md="3" class="mb-2 mt-0">
              <div class="text-right"></div>
            </v-col>
          </v-row>

          <v-data-table
            :headers="getHeaders()"
            :items="transformData()"
            :items-per-page="12"
            :hide-default-footer="true"
            class="row-pointer"
            v-if="this.currentStaff"
            :mobile-breakpoint='0'
          >
            <template
              v-for="date_header in getHeaders()"
              v-slot:[`item.${date_header.value}`]="{ item }"
            >
              <!-- style attendance status -->
              <div :key="date_header.value">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-if="(moment(moment(new Date()).format('LL')).isSame(moment(date_header.value + ' ' +item.month).format('LL')) 
                      && (item[date_header.value]=='A' || item[date_header.value]=='HD'))" 
                      class="black--text" color="rgba(0,0,0,0)">
                    </span>
                    <span v-else  :class="style_mapping[item[date_header.value] == '-' ? '-' : item[date_header.value]].class" v-bind="attrs" v-on="on">
                      {{ item[date_header.value] == "-" ? "-" : item[date_header.value]}}
                      <v-divider v-if="item.notes[date_header.value] != '-' && item.notes[date_header.value]" class="font-weight-bold black"></v-divider>
                    </span>
                  </template>
                  <span>{{ item.notes[date_header.value] }}</span>
                </v-tooltip>
                <strong v-if="item.late_marks[date_header.value]" class="red--text">(L)</strong>
              </div>
            </template>
            <!-- month name, actions -->
            <template v-slot:item.month="{ item }">
              <!-- link to staff-specific page -->
              <router-link
                :to="
                {
                  name: 'StaffMonthlyAttendance',
                  params: {
                    staff_id: currentStaff.id,
                    month_id: moment().month(item.month.split(/(\s+)/)[0]).format('M'),
                    year_id: Number(item.month.substr(item.month.length - 4)),
                  },

                }"
              >
                <h4>{{ item.month }}</h4>
              </router-link>
            </template>
          </v-data-table>

          <!-- absent/present/invalid... - table LEGENDS -->
          <div class="my-4">
            <v-row class="">
              <v-col
                v-if="this.currentStaff"
                cols="12"
                md="12"
                align="left"
                class="px-6 font-weight-medium"
              >
                <span class="success--text font-weight-bold">
                  P : Present
                </span>
                <span>│</span>
                <span class="success--text text--darken-2 font-weight-bold">
                  OT : Overtime
                </span>
                <span>│</span>
                <span class="red--text text--darken-3 font-weight-bold">
                  A : Absent
                </span>
                <span>│</span>
                <span class="blue--text font-weight-bold"> H : Holiday </span>
                <span>│</span>
                <span class="orange--text font-weight-bold">
                  PL : Paid Leave
                </span>
                <span>│</span>
                <span class="pink--text text--darken-1 font-weight-bold">
                  UL : Unpaid Leave
                </span>
                <span>│</span>
                <span class="yellow--text text--darken-1 font-weight-bold">
                  HD : Half Day
                </span>
                <span>│</span>
                <span class="purple--text text--darken-1 font-weight-bold">
                  W : Weekly Off
                </span>
                <span>│</span>
                <span class="red--text text--darken-1 font-weight-bold"> (L) : Late Mark </span>
                <span>│</span>
                <span class="font-weight-bold"> - : Invalid </span>
                <span>│</span>
                <span class="font-weight-bold"> _ : Notes Recorded </span>
              </v-col>
              <!-- default text if staff not selected -->
              <v-col
                v-if="!this.currentStaff"
                class="black--text font-weight-bold"
              >
                Please select a staff name to get attendance data
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import StaffAttendanceAnalytics from "@components/staff_attendance/StaffAttendanceAnalytics.vue";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import JsonExcel from "vue-json-excel";
import endpoints from "@api/repository";

export default {
  name: "StaffAttendanceDetail",
  components: {
    StaffAttendanceAnalytics,
    downloadExcel: JsonExcel,
  },

  data() {
    return {
      moment: moment,
      dateRange: null,

      menu: false,
      current_month_year: {
        // store current month,year
        month: null,
        year: null,
      },
      snackbar: {
        visible: false,
        text: "",
      },
      export_in_progress: false,
      export_fields: {
        0: "month",
      },
      currentStaff: null, //Stores all the selected staff details
      chartData: null, // store data from api

      staffData: [],
      attendanceData: [], // attendance data will be stored here
      style_mapping:{
        "A": {
          "class":"red--text text--darken-3 font-weight-bold",
        },
        "UL":{
          "class":"red--text text--darken-1 font-weight-bold",
        },
        "P":{
          "class":"success--text font-weight-bold",
        },
        "H":{
          "class":"blue--text font-weight-bold",
        },
        "PL":{
          "class": "orange--text font-weight-bold"
        },
        "HD":{
          "class":"yellow--text text--darken-1 font-weight-bold"
        },
        "OT": {
          "class": "success--text text--darken-2 font-weight-bold",
        },
        "W": {
          "class": "purple--text text--darken-1 font-weight-bold",
        },
        "-":{
          "color": "rgba(0,0,0,0)",
          "class": "black--text"
        },
      },
    };
  },
  props: ["staff_id"], // get analytics data and staff_id
  computed: {
    formattedDateRange() {
      if (!this.dateRange) return;

      var formatted =
        moment(this.dateRange[0]).format("D MMM, YYYY") +
        " - " +
        moment(this.dateRange[1]).format("D MMM, YYYY");
      return formatted;
    },

    ownView(){
      if(this.staffData.length == 0) return [];
      if(!this.currentUser.privileges.canViewAllStaffAttendanceDetails){
        return this.staffData.filter(x => x.id == this.currentUser.id)
      }else{
        return this.staffData;
      }
    },

    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    // headers list
    getHeaders() {
      let headers = [
        // header names
        {
          text: "Month",
          align: "left",
          sortable: true,
          value: "month",
          width: 130,
        },
      ];

      let header = [];
      let num_days = 31;
      for (let i = 1; i <= num_days; i++) {
        // add no. of days from 1-31 in header list
        header.push({
          text: String(i),
          align: "center",
          sortable: false,
          value: String(i),
        });
      }
      return headers.concat(header);
    },

    // export data in excel format
    async getExportData() {
      this.export_in_progress = true; //loading and disabling the button
      var res = this.transformData(); //storing output_list in res
      this.export_in_progress = false;
      return res;
    },

    // create headers for export excel data
    async createExportHeaders() {
      var dateHeader = {};
      var temp = {};
      for (var i = 1; i <= 31; i++) {
        temp[i] = String(i); //data in {1:1,2:2,......} format
        Object.assign(dateHeader, temp); //temp properties to dateHeader
      }
      Object.assign(this.export_fields, dateHeader);
    },

    // Handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    // name of file to be exported
    getExportName() {
      return "StaffAttendanceData_" + this.currentStaff.full_name + ".xls";
    },

    // get all staff details
    async getAllStaff() {
      var url = endpoints.getAllStaff + "?all=true";
      this.staffData = await api.call(this.apiEssentials, url);
    },

    // form month,year string from month no, year
    findMonthYear(month, year) {
      let monthYearString =
        moment()
          .month(month - 1)
          .format("MMMM") +
        " " +
        String(year);
      return monthYearString;
    },

    // transform received api response to records for data-table
    transformData() {
      // create output list
      let output_list = [];
      this.attendanceData.map((data) => {
        // traverse attendance data to find if month present in output list
        var monthName = this.findMonthYear(data.month, data.year);
        if (output_list.find((obj) => obj.month == monthName)) {
          return; // if month already exists in output_list, end.
        }
        //else add a new object with month name
        var newMonthObject = {
          month: monthName,
          notes: {},
          late_marks: []
        };
        output_list.push(newMonthObject);
      });

      this.attendanceData.map((data) => {
        // traverse attendance data to check and set attendance values
        var monthName = this.findMonthYear(data.month, data.year);
        var monthObject = output_list.find((obj) => obj.month == monthName);
        monthObject[String(data.day)] = data.status;
        monthObject.notes[String(data.day)] = data.notes;
        monthObject.late_marks[String(data.day)] = data.is_late;

      });

      // marks others as invalid
      for (var i = 1; i <= 31; i++) {
        output_list.map((outputMonthObject) => {
          if (!(String(i) in outputMonthObject)) {
            outputMonthObject[String(i)] = "-";
          }
          if (!(String(i) in outputMonthObject.notes)) {
            outputMonthObject.notes[String(i)] = "";
          }
          if (!(String(i) in outputMonthObject.late_marks)){
            outputMonthObject.late_marks[String(i)] = false;
          }
        });
      }
      return output_list;
    },

    // get attendance data of selected staff name
    async getAttendanceFromId(staffId = this.currentStaff.id) {
      this.dateRange = null;
      this.chartData = null; // clear chart data everytime a new staff is selected

      if (staffId && !this.currentStaff) {
        for (var i = 0; i < this.staffData.length; i++) {
          if (staffId == this.staffData[i].id) {
            this.currentStaff = {
              id: staffId,
              name: this.staffData[i].full_name,
            };
            break;
          }
        }
      }

      var url = endpoints.getStaffAttendance + `?staff_id=${staffId}`;
      this.attendanceData = await api.call(this.apiEssentials, url);
    },

    async getStaffAttendanceAnalytics() {
      this.chartData = null;
      var url = endpoints.getStaffAttendanceAnalytics;

      if (this.dateRange) {
        this.$refs.menu.save(this.dateRange); // save the selected dates
        url += `?staff_id=${this.currentStaff.id}&start_date=${this.dateRange[0]}&end_date=${this.dateRange[1]}`;
        this.chartData = await api.call(this.apiEssentials, url);
      }
    },
  },

  async created() {
    this.createExportHeaders();
    await this.getAllStaff();

    // to handle router link from attendance dashboard page
    if (this.staff_id) {
      this.getAttendanceFromId(this.staff_id);
    }

    this.dateRange = null;
  },
};
</script>

<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;

  color: #000000;
  vertical-align: middle;
}

h2 {
  font-size: 24px;
}

.row-pointer {
  cursor: pointer;
}
</style>
